import COLORS from 'pared/constants/colors'

import { IConfigsType } from '../../types'

const fwWingstopCorporateLossPreventionConfig: IConfigsType = {
  'fw_wingstop-corporate-base-zj8m1ewp': {
    '/:brand/corporate_loss_prevention': {
      variables: ['corporateGroup', 'discountType', 'lastTimeRange'],
      groupFilter: {
        api: 'corporateFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
          'custom',
        ],
      },
      lossPreventionKpis: {
        type: 'list',
        api: 'fwWingstopListLocationGroupLossPreventionKpis',
        title: 'Loss Prevention',
        subTitle: [
          'Percentages below is a % of Net Sales',
          '100% Disc/Emp is the sum "100%" and "100% Employee" on NBO 1.13 report',
          'Other % Combined is the same as "Olo Coupon" on NBO 1.13 report',
          'Sum of "All with Purch" and "All Non Purch Promos" is the same as "Total Promo $" on NBO 1.13 report',
        ],
        fieldWidth: '160px',
        fields: [
          {
            content: {
              key: 'discountCompsTotal',
            },
            bottom: 'Total Discounts',
          },
          {
            content: {
              key: 'lossPreventionCompsCashOverOrShort',
            },
            bottom: 'Cash +/-',
          },
          {
            content: {
              key: 'lossPreventionCheckCountVoids',
            },
            bottom: 'Void Count',
          },
          {
            content: {
              key: 'lossPreventionCheckCountPercentVoids',
            },
            bottom: '% Checks with Voids',
          },
        ],
      },
      discountTypeFilters: {
        type: 'grid',
        children: {
          title: {
            type: 'title',
            title: 'Discounts',
          },
          columns: {
            type: 'select',
            value: 'discountType.value',
            onChange: 'discountType.onChange',
            options: 'discountType.options',
            label: 'Type',
          },
        },
      },
      downloadDiscount: {
        type: 'download-csv',
        api: 'fwWingstopLossPrevention',
        fileName: 'getexpo-far-west-discount-detail',
        message: 'Download as CSV',
        fields: [
          'groupInfo',
          {
            key: 'discountComps100DiscEmp',
            title: '100% Disc. / Emp $',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("100DiscEmp")) %>',
          },
          {
            key: 'discountCompsPercent100DiscEmp',
            title: '100% Disc. / Emp %',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("100DiscEmp")) %>',
          },
          {
            key: 'discountComps100Remake',
            title: '100% Remake $',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("100Remake")) %>',
          },
          {
            key: 'discountCompsPercent100Remake',
            title: '100% Remake %',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("100Remake")) %>',
          },
          {
            key: 'discountCompsOtherSCombined',
            title: 'Other % Combined $',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("otherSCombined")) %>',
          },
          {
            key: 'discountCompsPercentOtherSCombined',
            title: 'Other % Combined %',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("otherSCombined")) %>',
          },
          {
            key: 'discountCompsAllWithPurch',
            title: 'All With Purch $',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("allWithPurch")) %>',
          },
          {
            key: 'discountCompsPercentAllWithPurch',
            title: 'All With Purch %',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("allWithPurch")) %>',
          },
          {
            key: 'discountCompsAllNonPurchPromos',
            title: 'All Non Purch Promos $',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("allNonPurchPromos")) %>',
          },
          {
            key: 'discountCompsPercentAllNonPurchPromos',
            title: 'All Non Purch Promos %',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("allNonPurchPromos")) %>',
          },
          {
            key: 'discountCompsOpenDiscounts',
            title: 'Open Discounts $',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("openDiscounts")) %>',
          },
          {
            key: 'discountCompsPercentOpenDiscounts',
            title: 'Open Discounts %',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("openDiscounts")) %>',
          },
          {
            key: 'discountCompsTotal',
            title: 'Total Discounts $',
          },
          {
            key: 'discountCompsPercentTotal',
            title: 'Total Discounts %',
          },
          {
            key: 'grossSales',
            title: 'Net Sales',
          },
        ],
      },
      discountBreakdownByStore: {
        type: 'table-v2',
        api: 'fwWingstopLossPrevention',
        pagination: { pageSize: 20 },
        row: {
          pinning: {
            top: ['summary'],
          },
        },
        sorting: [
          {
            id: '<%- corporateGroup?.tableColumns[0].key %>',
            desc: true,
          },
        ],
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            sortable: true,
          },
          {
            key: '100DiscEmp',
            title: '100% Disc. / Emp',
            align: 'center',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("100DiscEmp")) %>',
            children: [
              {
                key: 'discountComps100DiscEmp',
                title: '$',
                width: '75px',
                align: 'center',
                sortable: true,
              },
              {
                key: 'discountCompsPercent100DiscEmp',
                title: '%',
                width: '75px',
                align: 'center',
                sortable: true,
                background: {
                  range: [0, 100],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values.discountCompsPercent100DiscEmpHeatmap %>',
                },
              },
            ],
          },
          {
            key: '100Remake',
            title: '100% Remake',
            align: 'center',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("100Remake")) %>',
            children: [
              {
                key: 'discountComps100Remake',
                title: '$',
                width: '75px',
                align: 'center',
                sortable: true,
              },
              {
                key: 'discountCompsPercent100Remake',
                title: '%',
                width: '75px',
                align: 'center',
                sortable: true,
                background: {
                  range: [0, 100],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values.discountCompsPercent100RemakeHeatmap %>',
                },
              },
            ],
          },
          {
            key: 'otherSCombined',
            title: 'Other % Combined',
            align: 'center',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("otherSCombined")) %>',
            children: [
              {
                key: 'discountCompsOtherSCombined',
                title: '$',
                width: '75px',
                align: 'center',
                sortable: true,
              },
              {
                key: 'discountCompsPercentOtherSCombined',
                title: '%',
                width: '75px',
                align: 'center',
                sortable: true,
                background: {
                  range: [0, 100],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value:
                    '<%- values.discountCompsPercentOtherSCombinedHeatmap %>',
                },
              },
            ],
          },
          {
            key: 'allWithPurch',
            title: 'All With Purch',
            align: 'center',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("allWithPurch")) %>',
            children: [
              {
                key: 'discountCompsAllWithPurch',
                title: '$',
                width: '75px',
                align: 'center',
                sortable: true,
              },
              {
                key: 'discountCompsPercentAllWithPurch',
                title: '%',
                width: '75px',
                align: 'center',
                sortable: true,
                background: {
                  range: [0, 100],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value:
                    '<%- values.discountCompsPercentAllWithPurchHeatmap %>',
                },
              },
            ],
          },
          {
            key: 'allNonPurchPromos',
            title: 'All Non Purch Promos',
            align: 'center',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("allNonPurchPromos")) %>',
            children: [
              {
                key: 'discountCompsAllNonPurchPromos',
                title: '$',
                width: '75px',
                align: 'center',
                sortable: true,
              },
              {
                key: 'discountCompsPercentAllNonPurchPromos',
                title: '%',
                width: '75px',
                align: 'center',
                sortable: true,
                background: {
                  range: [0, 100],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value:
                    '<%- values.discountCompsPercentAllNonPurchPromosHeatmap %>',
                },
              },
            ],
          },
          {
            key: 'openDiscounts',
            title: 'Open Discounts',
            align: 'center',
            hide: '<%- !discountType.value.some(v => v.includes("all") || v.includes("openDiscounts")) %>',
            children: [
              {
                key: 'discountCompsOpenDiscounts',
                title: '$',
                width: '75px',
                align: 'center',
                sortable: true,
              },
              {
                key: 'discountCompsPercentOpenDiscounts',
                title: '%',
                width: '75px',
                align: 'center',
                sortable: true,
                background: {
                  range: [0, 100],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value:
                    '<%- values.discountCompsPercentOpenDiscountsHeatmap %>',
                },
              },
            ],
          },
          {
            key: 'total',
            title: 'Total Discounts',
            align: 'center',
            children: [
              {
                key: 'discountCompsTotal',
                title: '$',
                width: '75px',
                align: 'center',
                sortable: true,
              },
              {
                key: 'discountCompsPercentTotal',
                title: '%',
                width: '75px',
                align: 'center',
                sortable: true,
                background: {
                  range: [0, 100],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value: '<%- values.discountCompsPercentTotalHeatmap %>',
                },
              },
            ],
          },
          {
            key: 'grossSales',
            title: 'Net Sales',
            width: '150px',
            align: 'center',
            sortable: true,
          },
        ],
      },
      discountTrendTimeRangeFilters: {
        type: 'grid',
        children: {
          title: {
            type: 'title',
            title: 'Discounts Trend',
          },
          columns: {
            type: 'select',
            value: 'lastTimeRange.value',
            onChange: 'lastTimeRange.onChange',
            options: 'lastTimeRange.options',
            label: ' ',
          },
        },
      },
      discountCompsTrendChart: {
        type: 'line-chart',
        api: 'trendLocationGroupDiscount',
        width: 1100,
        height: 350,
        label: 'date',
        datasets: [
          {
            key: 'discountCompsTotal',
            label: 'Total Discount',
            borderColor: COLORS.Pomodoro,
            backgroundColor: COLORS.Pomodoro,
          },
        ],
        scaleTypes: {
          y: {
            type: 'price',
          },
        },
        options: {
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            y: {
              title: {
                text: '$',
              },
            },
          },
        },
      },
      cachBreakdownByStore: {
        type: 'table-v2',
        title: 'Cash',
        api: 'fwWingstopLossPrevention',
        pagination: { pageSize: 20 },
        sorting: [
          {
            id: '<%- corporateGroup?.tableColumns[0].key %>',
            desc: true,
          },
        ],
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            sortable: true,
          },
          {
            key: 'cashOverOrShort',
            title: 'Cash +/-',
            align: 'center',
            children: [
              {
                key: 'lossPreventionCompsCashOverOrShort',
                title: '$',
                width: '150px',
                align: 'center',
                sortable: true,
              },
            ],
          },
          {
            key: 'voids',
            title: 'Void',
            align: 'center',
            children: [
              {
                key: 'lossPreventionCheckCountVoids',
                title: '#',
                width: '100px',
                align: 'center',
                sortable: true,
              },
              {
                key: 'lossPreventionCheckCountPercentVoids',
                title: '%',
                width: '100px',
                align: 'center',
                sortable: true,
              },
            ],
          },
        ],
      },
      lossPreventionsTrendTimeRangeFilters: {
        type: 'grid',
        children: {
          title: {
            type: 'title',
            title: 'Void Trend',
          },
          columns: {
            type: 'select',
            value: 'lastTimeRange.value',
            onChange: 'lastTimeRange.onChange',
            options: 'lastTimeRange.options',
            label: ' ',
          },
        },
      },
      lossPreventionsTrendChart: {
        type: 'line-chart',
        api: 'trendLocationGroupLossPrevention',
        width: 1100,
        height: 350,
        label: 'date',
        datasets: [
          {
            key: 'lossPreventionCheckCountVoids',
            label: 'Void',
            borderColor: COLORS.Pomodoro,
            backgroundColor: COLORS.Pomodoro,
          },
        ],
        scaleTypes: {
          y: {
            type: 'string',
          },
        },
        options: {
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            y: {
              title: {
                text: 'Count',
              },
            },
          },
        },
      },
      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'systemwide-loss-prevention',
        sendStoreId: false,
      },
    },
  },
}

export default fwWingstopCorporateLossPreventionConfig
